import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SuiviPrestation } from 'src/app/shared/models/suiviPrestation';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class SuiviPrestationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllSuiviPrestation(): Observable<SuiviPrestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.suiviPrestationUrl}/all`,
			'getAllSuiviPrestation'
		);
	}

	importSuiviPrestation(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'suiviPrestation.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.suiviPrestationUrl}/import`,
			`importSuiviPrestation`,
			formData
		);
	}

	getSuiviPrestationById(id: number): Observable<SuiviPrestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.suiviPrestationUrl}/get/${id}`,
			'getSuiviPrestationById'
		);
	}

	getByPrestation(prestationId: number): Observable<SuiviPrestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.suiviPrestationUrl}/getByPrestation/${prestationId}`,
			'getSuiviPrestationById'
		);
	}

	updateSuiviPrestation(suiviPrestation: SuiviPrestation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.suiviPrestationUrl}/update/${suiviPrestation.id}`,
			'updateSuiviPrestation',
			suiviPrestation
		);
	}

	addSuiviPrestation(suiviPrestation: SuiviPrestation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.suiviPrestationUrl}/add`,
			'addSuiviPrestation',
			suiviPrestation
		);
	}

	deleteSuiviPrestation(suiviPrestationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.suiviPrestationUrl}/delete/${suiviPrestationId}`,
			`deleteSuiviPrestation`
		);
	}
}
